// extracted by mini-css-extract-plugin
export default {"body":"warehouses_body__KQYqU","strong":"warehouses_strong__XSI32"};